export default __webpack_public_path__ + "static/media/love.b4e2adbe.png";